import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';

import { AuthService } from '../auth/auth.service';
import { isVpnRequiredError } from '../auth/vpn-required';

import { GlobalErrorHandlerService } from './global-error-handler.service';

const FRONTEND_ERROR_ENDPOINT = '/api/public/frontend-error';

export const globalErrorHttpInterceptor: HttpInterceptorFn = (request, next) => {
  const globalErrorHandlerService = inject(GlobalErrorHandlerService);
  const authService = inject(AuthService);

  return next(request).pipe(
    catchError((error) => {
      if (isVpnRequiredError(error)) {
        authService.handleVpnRequired();
      }

      if (!request.url.includes(FRONTEND_ERROR_ENDPOINT)) {
        globalErrorHandlerService.capture(error, {
          source: 'http',
          requestUrl: request.url
        });
      }

      return throwError(() => error);
    })
  );
};
